export default __webpack_public_path__ + "img/kl_members_dinner_2022-fe9954ab34b964d040a53d226016f725.png";